import { MoonStar } from "lucide-react";
import { CARD_CLASS } from "../styles";

type Props = {
  minStay: number[] | null | undefined;
};

export default function SelectedHotelMinStayCard({ minStay }: Props) {
  if (!minStay?.length) return null;

  return (
    <section className={CARD_CLASS}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
          <MoonStar size={18} />
        </span>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-400">Срок заселения</p>
          <p className="mt-1 text-base font-semibold text-slate-900">{minStay.join(", ")}</p>
        </div>
      </div>
    </section>
  );
}
